import { BALocationModel } from '@/models'

export class EventLocationModel extends BALocationModel {
    photo?: string;
    online?: boolean;
}